import { render, staticRenderFns } from "./solicitud-material.vue?vue&type=template&id=143bf63c"
import script from "./solicitud-material.vue?vue&type=script&lang=js"
export * from "./solicitud-material.vue?vue&type=script&lang=js"
import style0 from "./solicitud-material.vue?vue&type=style&index=0&id=143bf63c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports